<template>
  <iframe class="iframe" :src="url" :title="title" :style="cssHeight" frameborder="0" width="100%" :height="height" 
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen></iframe>    
</template>

<script>
export default {
  name: "FrameView",
  props: {
    url: String,
    title: String,
    height: {
      type: Number,
      default: 500
    }
  },
  methods: {},
  computed: {
    cssHeight() {
      return {
        '--height': this.height + 'px'
      }
    }
  }
};
</script>

<style scoped>
    .iframe {
        border: 0;
        width: 100%;
        height: var(--height);
    }
</style>